/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import React from "react";
import styled from "styled-components";

const Carousel = ({
  activeIndex,
  data,
  columns = 1,
  onPrevClick,
  onNextClick,
  totalSlides,
  showArrows = true,
  renderItem
}) => {
  return (
    <Wrapper>
      <DataContainer>
        <Data $activeIndex={activeIndex}>
          {[...Array(totalSlides)].map((_, slideIndex) => (
            <Slide key={slideIndex}>
              {[...Array(columns)].map((_, colIndex) => {
                const itemIndex = slideIndex * columns + colIndex;
                const item = data[itemIndex];

                if (!item) return null;

                return (
                  <SlideItem key={colIndex} $columns={columns}>
                    {renderItem
                      ? renderItem(item, itemIndex)
                      : item.imgUrl && <Image src={item.imgUrl} alt={`Slide ${itemIndex + 1}`} />
                    }
                  </SlideItem>
                );
              })}
            </Slide>
          ))}
        </Data>
      </DataContainer>

      {showArrows && totalSlides > 1 && (
        <>
          <NavigationButton onClick={onPrevClick} $position="left">
            <NavigationIcon>‹</NavigationIcon>
          </NavigationButton>
          <NavigationButton onClick={onNextClick} $position="right">
            <NavigationIcon>›</NavigationIcon>
          </NavigationButton>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
    position: relative;
    margin: 1rem 0 1rem 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
`;

const DataContainer = styled.div`
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
`;

const Data = styled.div`
    display: flex;
    transform: ${({ $activeIndex }) => `translateX(-${$activeIndex * 100}%)`};
    transition: transform 0.5s linear;
`;

const Slide = styled.div`
    flex: 0 0 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 12px;
    box-sizing: border-box;
`;

const SlideItem = styled.div`
`;

const Image = styled.img`
    width: 100%;
    padding-top: 8px;
`;

const NavigationButton = styled.button`
    position: absolute;
    top: 0;
    ${({ $position }) => $position}: 0;
    background-color: #1C1C1C;
    width: 12px;
    height: 100%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: opacity 0.3s ease;
    
    &:hover {
        opacity: 1;
    }

    &:focus {
        outline: none;
    }
`;

const NavigationIcon = styled.span`
    color: #5A5A5A;
    font-size: 6rem;
    width: 6rem;
    height: 6rem;
`;

export default React.memo(Carousel);